import { render } from "./PaymentSourcesPage.vue?vue&type=template&id=534818e6&scoped=true"
import script from "./PaymentSourcesPage.vue?vue&type=script&lang=js"
export * from "./PaymentSourcesPage.vue?vue&type=script&lang=js"

import "./PaymentSourcesPage.vue?vue&type=style&index=0&id=534818e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534818e6"]])

export default __exports__